export enum FieldValidationHintState {
  VALID = 'valid',
  INVALID = 'invalid',
  DEFAULT = 'default',
}
